import classNames from "classnames";
import { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import {
  useLegislationAgenciesQuery,
  useLegislationNormsQuery,
} from "../../../../services";
import PeriodSelector, { OnPeriodChangePayload } from "../_periodSelector";
import Select from "../_select";
import "./style.scss";

interface DetailedSearchFilterProps {
  isActive: boolean;
  isDisabled: boolean;
  normType: string;
  agency: string;
  number: string;
  article: string;
  onActivate: () => void;
  onNormTypeChange: (value: string) => void;
  onAgencyChange: (value: string) => void;
  onNumberChange: (value: string) => void;
  onArticleChange: (value: string) => void;

  onPeriodChange: (data: OnPeriodChangePayload) => void;
  period: OnPeriodChangePayload;
}

export function DetailedSearchFilter({
  isActive,
  isDisabled,
  normType,
  agency,
  number,
  article,
  onActivate,
  onNormTypeChange,
  onAgencyChange,
  onNumberChange,
  onArticleChange,
  onPeriodChange,
  period,
}: DetailedSearchFilterProps) {
  const [showAgencys, setShowAgencys] = useState(true);

  const handleInteraction = () => {
    if (!isActive) {
      onActivate();
    }
  };

  const { data, isPending } = useLegislationNormsQuery();
  const {
    data: agencys,

    isPending: agencysLoading,
  } = useLegislationAgenciesQuery();

  useEffect(() => {
    const currentNormType = data?.find((data) => data.id === normType);

    if (currentNormType && currentNormType.tipo === "superior") {
      setShowAgencys(false);
      onAgencyChange("");
    } else {
      setShowAgencys(true);
    }
  }, [data, normType]);

  return (
    <div
      className={classNames(
        "detailed-search-filter",
        isActive && "detailed-search-filter-active",
        isDisabled && "detailed-search-filter-disabled",
      )}
      onClick={handleInteraction}
    >
      <div className="detailed-search-filter-header">
        <div
          className={classNames(
            "detailed-search-filter-radio ",
            isActive ? "detailed-search-filter-radio-active" : "",
          )}
        >
          {isActive && <div className="detailed-search-filter-radio-dot" />}
        </div>
        <span
          className={classNames(
            "detailed-search-filter-label ",
            isActive ? "detailed-search-filter-label-active" : "",
          )}
        >
          Pesquisa Detalhada
        </span>
      </div>

      <div className="detailed-search-filter-grid">
        <div className="detailed-search-filter-col-full">
          <label className="detailed-search-filter-field-label">
            Tipo de Norma
          </label>
          <Select
            options={(data || [])?.map((data) => ({
              label: data.nome,
              value: data.id,
            }))}
            searchable
            loading={isPending}
            value={normType}
            onSelect={(value) => {
              onNormTypeChange(value);
              handleInteraction();
            }}
            onFocus={handleInteraction}
            disabled={isDisabled}
            placeholder="Selecione o item"
          />
        </div>
        {showAgencys && (
          <div className={classNames("detailed-search-filter-col-full")}>
            <label className="detailed-search-filter-field-label">Orgão</label>
            <Select
              options={(agencys || [])?.map((data) => ({
                ...data,
              }))}
              searchable
              value={agency}
              onSelect={(value) => {
                onAgencyChange(value);
                handleInteraction();
              }}
              onFocus={handleInteraction}
              loading={agencysLoading}
              disabled={isDisabled}
              placeholder="Selecione o item"
            />
          </div>
        )}

        <div>
          <label className="detailed-search-filter-field-label">Numero</label>
          <Form.Control
            type="text"
            placeholder="Ex: 1234"
            value={number}
            onChange={(e) => {
              onNumberChange(e.target.value);
              handleInteraction();
            }}
            onFocus={handleInteraction}
            disabled={isDisabled}
            size="sm"
          />
        </div>

        <div>
          <label className="detailed-search-filter-field-label">Artigo</label>
          <Form.Control
            type="text"
            placeholder="Ex: Art. 5"
            value={article}
            onChange={(e) => {
              onArticleChange(e.target.value);
              handleInteraction();
            }}
            onFocus={handleInteraction}
            disabled={isDisabled}
            size="sm"
          />
        </div>

        <div className="detailed-search-filter-col-full">
          <PeriodSelector
            mode="select"
            onPeriodChange={onPeriodChange}
            period={period}
          />
        </div>
      </div>
    </div>
  );
}
